import * as cssVariablesStyles from '../../css/var-export.scss';
import {LangKeyType} from '../../provider/locale/translation/type';
import {
    CommonEventStatusEnum,
    EventAgeEnum,
    EventCatalogStatusEnum,
    EventTypeEnum,
} from '../../service/events/events-type';
import {NeverError} from '../../util/error';

export function getEventStatusConfig(status: CommonEventStatusEnum): {
    langKey: LangKeyType;
    badgeColor: string;
    tagColor: string;
} {
    switch (status) {
        case CommonEventStatusEnum.Draft:
            return {
                langKey: 'EVENTS__STATUS__DRAFT',
                badgeColor: cssVariablesStyles.gray7,
                tagColor: 'default',
            };
        case CommonEventStatusEnum.Planned:
            return {
                langKey: 'EVENTS__STATUS__PLANNED',
                badgeColor: cssVariablesStyles.blue50,
                tagColor: 'blue',
            };
        case CommonEventStatusEnum.InProgress:
            return {
                langKey: 'EVENTS__STATUS__IN_PROGRESS',
                badgeColor: cssVariablesStyles.orange50,
                tagColor: 'orange',
            };
        case CommonEventStatusEnum.Sent:
            return {
                langKey: 'EVENTS__STATUS__SENT',
                badgeColor: cssVariablesStyles.blue50,
                tagColor: 'blue',
            };
        case CommonEventStatusEnum.Deleted:
            return {
                langKey: 'EVENTS__STATUS__DELETED',
                badgeColor: cssVariablesStyles.danger50,
                tagColor: 'red',
            };
        default: {
            throw new NeverError(status);
        }
    }
}

export function getEventCatalogStatusConfig(status: EventCatalogStatusEnum): {
    langKey: LangKeyType;
    tagColor: string;
} {
    switch (status) {
        case EventCatalogStatusEnum.Active:
            return {langKey: 'EVENTS__CATALOG_STATUS__ACTIVE', tagColor: 'green'};
        case EventCatalogStatusEnum.Planned:
            return {langKey: 'EVENTS__CATALOG_STATUS__PLANNED', tagColor: 'blue'};
        case EventCatalogStatusEnum.Finished:
            return {langKey: 'EVENTS__CATALOG_STATUS__FINISHED', tagColor: 'default'};
        case EventCatalogStatusEnum.OnModeration:
            return {langKey: 'EVENTS__CATALOG_STATUS__ON_MODERATION', tagColor: 'orange'};
        case EventCatalogStatusEnum.Rejected:
            return {langKey: 'EVENTS__CATALOG_STATUS__REJECTED', tagColor: 'red'};
        case EventCatalogStatusEnum.Deleted:
            return {langKey: 'EVENTS__CATALOG_STATUS__DELETED', tagColor: 'red'};
        case EventCatalogStatusEnum.Unknown:
            return {langKey: 'EVENTS__CATALOG_STATUS__PENDING', tagColor: 'default'};
        default: {
            throw new NeverError(status);
        }
    }
}

export function getEventStatusFilterOptions(): Array<{value: CommonEventStatusEnum; langKey: LangKeyType}> {
    return [
        CommonEventStatusEnum.Draft,
        CommonEventStatusEnum.Planned,
        CommonEventStatusEnum.InProgress,
        CommonEventStatusEnum.Sent,
        CommonEventStatusEnum.Deleted,
    ].map((value) => ({value, langKey: getEventStatusConfig(value).langKey}));
}

const EVENT_TYPE_LANG_KEY_MAP: Record<EventTypeEnum, LangKeyType> = {
    [EventTypeEnum.Concert]: 'EVENTS__TYPE__CONCERT',
    [EventTypeEnum.Cinema]: 'EVENTS__TYPE__CINEMA',
    [EventTypeEnum.Children]: 'EVENTS__TYPE__CHILDREN',
    [EventTypeEnum.Exhibition]: 'EVENTS__TYPE__EXHIBITION',
    [EventTypeEnum.Sports]: 'EVENTS__TYPE__SPORTS',
    [EventTypeEnum.Excursion]: 'EVENTS__TYPE__EXCURSION',
    [EventTypeEnum.StandUp]: 'EVENTS__TYPE__STAND_UP',
    [EventTypeEnum.Show]: 'EVENTS__TYPE__SHOW',
    [EventTypeEnum.Quest]: 'EVENTS__TYPE__QUEST',
    [EventTypeEnum.Musical]: 'EVENTS__TYPE__MUSICAL',
    [EventTypeEnum.MasterClass]: 'EVENTS__TYPE__MASTER_CLASS',
    [EventTypeEnum.Lecture]: 'EVENTS__TYPE__LECTURE',
    [EventTypeEnum.ThematicDinner]: 'EVENTS__TYPE__THEMATIC_DINNER',
    [EventTypeEnum.Tasting]: 'EVENTS__TYPE__TASTING',
    [EventTypeEnum.Training]: 'EVENTS__TYPE__TRAINING',
    [EventTypeEnum.Webinar]: 'EVENTS__TYPE__WEBINAR',
    [EventTypeEnum.Conference]: 'EVENTS__TYPE__CONFERENCE',
    [EventTypeEnum.Forum]: 'EVENTS__TYPE__FORUM',
    [EventTypeEnum.Occasion]: 'EVENTS__TYPE__OCCASION',
};

export function getEventTypeLangKey(eventType: EventTypeEnum): LangKeyType {
    return EVENT_TYPE_LANG_KEY_MAP[eventType];
}

export function getEventAgeLabel(age: EventAgeEnum): string {
    return `${age}+`;
}
